interface LeadDashboardChartProps {
    percent: number;
}

const SIZE = 40;
const STROKE = 4.25;
const RADIUS = (SIZE - STROKE) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

const LeadDashboardChart = ({ percent }: LeadDashboardChartProps) => {
    const clamped = Math.min(Math.max(percent, 0), 100);
    const dash = (clamped / 100) * CIRCUMFERENCE;

    return (
        <svg
            className="leads-dashboard__chart-svg"
            viewBox={`0 0 ${SIZE} ${SIZE}`}
            aria-hidden="true"
        >
            <circle
                className="leads-dashboard__chart-track"
                cx={SIZE / 2}
                cy={SIZE / 2}
                r={RADIUS}
            />
            {clamped > 0 ? (
                <circle
                    className="leads-dashboard__chart-value"
                    cx={SIZE / 2}
                    cy={SIZE / 2}
                    r={RADIUS}
                    strokeDasharray={`${dash} ${CIRCUMFERENCE}`}
                />
            ) : null}
        </svg>
    );
};

export default LeadDashboardChart;
